import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { deleteButtonColor, textColor } from '../../sub-components/colors/colors';
import { AlertBar } from 'src/components/sub-components/AlertBar';
import {environment} from '../../../environments/environment';

export function  DeletePrivilege(props) {
  const classes = useStyles();
  const [alertOpen, setAlertOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [topic, setTopic] = useState("");
  const [message, setMessage] = useState("");
  const [loading,setLoading] = useState(false)

  const removeChild = async (privilege) => {
    console.log(privilege);
    console.log(props.child);

    for (const p of props.child) {
        await deletePrivilege(p.id);
    }

    removePrivilege(privilege);
};

const deletePrivilege =async (id) => {
    setLoading(true);

    try {
        const response = await fetch(`${environment.host}/ums/super/user-privilege/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')
            }
        });

        const data = await response.json();

        if (data.message === "Success") {
            setLoading(false);
            props.setAlertOpen(true);
            props.setSeverity("success");
            props.setTopic("Success");
            props.setMessage("Privilege deleted successfully");
            props.onClose();
            props.getPrivileges();
            setTimeout(() => {
                props.setAlertOpen(false);
            }, 4000);
        } else {
            props.setAlertOpen(true);
            props.setSeverity("error");
            props.setTopic("Error");
            props.setMessage(data.message);
            props.onClose();
            setLoading(false);
            setTimeout(() => {
                props.setAlertOpen(false);
            }, 3000);
        }
    } catch (error) {
        console.error('Error deleting privilege:', error);
        setLoading(false);
    }
};


  const removePrivilege =(privilege) =>{
    deletePrivilege(privilege.id)
  }


  return (
    <div>
      <Dialog open={props.open} maxWidth="md" className={classes.dialogOverlay} >
        <Grid item xs={12} md={12} style={{ padding: '20px' }}>
          <Typography>Do you really want to delete the privilege with ID {props.id}?</Typography>
        </Grid>
        <DialogActions style={{ width: "100%", justifyContent: 'right', marginTop: '10px'}}>
          <Button variant='contained' className={classes.cancel} onClick={() => props.onClose()}>
            Cancel
          </Button>
          <Button variant='contained' className={classes.delete} onClick={() => {removeChild(props.privilege)}}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <AlertBar open={alertOpen} severity={severity} topic={topic} message={message} />

    </div>
  );
};

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    dialogOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9999,
      "& .MuiBackdrop-root": {
        backgroundColor: "rgba(0, 0, 0, 0.1)", // Adjust the transparency as needed
      },
      "& .MuiPaper-root": {
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", // Adjust the shadow as needed
      },
    },

    delete: {
      backgroundColor: deleteButtonColor,
      color: "white",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    cancel: {
      backgroundColor: "white",
      color: textColor,
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    }
  }),
);
